module.exports = __webpack_public_path__ + "static/media/head-vr.a604bd9f.svg";